<div>
  <fcom-text-input
    [parentForm]="formGroup"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.passportNumber'"
    [controlName]="'passportNumber'"
  ></fcom-text-input>
</div>
<div class="col-2">
  <div class="col">
    <fin-datepicker
      [parentForm]="formGroup"
      [controlName]="'issueDate'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.fields.dateOfIssue.placeHolder'"
      [minDate]="expiryMinDate"
      [maxDate]="currentDate"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.dateOfIssue'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [theme]="DatepickerTheme.WEB_2"
    ></fin-datepicker>
  </div>
  <div class="col">
    <fin-datepicker
      [parentForm]="formGroup"
      [controlName]="'expirationDate'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.fields.dateOfExpiry.placeHolder'"
      [minDate]="currentDate"
      [maxDate]="expiryMaxDate"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.dateOfExpiry'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [theme]="DatepickerTheme.WEB_2"
    ></fin-datepicker>
  </div>
</div>
<div>
  <fin-select-input
    [parentForm]="formGroup"
    [controlName]="'nationality'"
    [options]="nationalities$ | async"
    [selectLabelTranslationKey]="'CORPORATE.corporatePortal.addUser.fields.nationality.placeholder'"
    [translationPrefix]="'CORPORATE.corporatePortal.addUser.fields.nationality'"
  ></fin-select-input>
</div>
